/* unplugin-vue-components disabled */import { render } from "./LoadingPage.vue?vue&type=template&id=0d1347d4&scoped=true"
import script from "./LoadingPage.vue?vue&type=script&lang=js"
export * from "./LoadingPage.vue?vue&type=script&lang=js"

import "./LoadingPage.vue?vue&type=style&index=0&id=0d1347d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1347d4"]])

export default __exports__